import config from "@/config"
import http from "@/utils/request"

export default {
    MiniProgramPay: {
		url: `${config.API_URL}/PCWechatPay/MiniProgramPay`,
		name: "小程序支付",
		post: async function(data){

			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
    QrCodePay: {
		url: `${config.API_URL}/PCWechatPay/QrCodePay`,
		name: "扫码支付",
		post: async function(data){
			//debugger
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
    Refund: {
		url: `${config.API_URL}/PCWechatPay/Refund`,
		name: "退款申请",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
    Query: {
		url: `${config.API_URL}/PCWechatPay/QueryByTransactionId`,
		name: "微信支付订单号查询",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
    Close: {
		url: `${config.API_URL}/PCWechatPay/OutTradeNoClose`,
		name: "关闭订单",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	CodePay: {
		url: `${config.API_URL}/PCWechatPay/CodePay`,
		name: "付款码支付",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	GetoutTradeNo:{
	    url: `${config.API_URL}/PayService/GetoutTradeNo`,
	    name: "交易查询",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	GetOutRequestNo:{
	    url: `${config.API_URL}/PayService/GetOutRequestNo`,
	    name: "交易查询",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	}
}
